import { EventBus } from "../../../eventbus";

export default {
  props: {
    label: String,
    sortKey: String,
    parentId: String,
    defaultActive: Boolean,
  },
  data() {
    return {
      active: this.defaultActive,
    };
  },
  created() {
    //file-sort-settings
    EventBus.$on(`${this.$options.name}-update`, (data) => {
      if (data.parentId === this.parentId) {
        //is same section
        if (data.sortKey === this.sortKey) {
          //if clicked on invert self
          this.active = !this.active;
        } else {
          this.active = false;
        }
      }
    });
  },
  methods: {
    updateSortOptions(e) {
      e.preventDefault();

      EventBus.$emit(`${this.$options.name}-update`, {
        sortKey: this.sortKey,
        parentId: this.parentId,
        isAsc: this.active,
      });
    },
  },
  watch: {
    defaultActive() {
      this.active = this.defaultActive;
    },
  },
};
